import React from 'react';

const SlicedNameData = ({dataToSlice}) => {
    const splittedData = dataToSlice?.toString()?.split(' ')
    const [firstName, secondName, thirdName] = !!splittedData
        ? [`${splittedData[1][0] ?? ''}.`, `${splittedData[0] ?? ''} `, `${splittedData[2][0] ?? ''}.`]
        : Array(3).fill('');
    return (
        dataToSlice?.length ? (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>
              {secondName}
                {firstName}
                {thirdName}
            </span>
        </div>) : <>Не указан</>
    );
};

export default SlicedNameData;